import {
  Alert,
  AppLayout,
  SideNavigation
} from '@cloudscape-design/components';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
// Page components
import { TopNavigationBar } from './Screens/Components/TopNavigation';
import { DocumentContext } from './context/documentContext';
import { UploadCSV } from './Screens/Components/UploadCSV';
// sidepanels
import { useContext, useEffect, useRef, useState } from 'react';
import { AdminRoute } from './Screens/AdminRoute';
import { EditDomains } from './Screens/Components/EditDomainControls';
import { UserContext } from './context/authContext';
import { ErrorReports } from './Screens/Components/errorReportPage';
import './App.css';
import { KnowledgeBaseSplash } from './Screens/Components/KnowledegeBaseSplash';
import { pdfjs } from 'react-pdf';
import { ProjectTableView } from './Screens/projectTableView';
import { DocumentViewerContainer } from './Screens/DocumentViewerContainer';
import { UploadDocument } from './Screens/Components/uploadViews/UploadDoc';
import { CostCalculator } from './Screens/Components/accountViews/costCalulator';
import { ManageUsers } from './Screens/Components/users/ManageUsers';
import { TandCModal } from './Screens/Components/tnc_modal/tncModal';
import { LandingPageNew } from './Screens/Components/landingPage/descriptiveLandingPage';
import { ChatWithSummaryNew } from './Screens/Components/Chat/chatWithSummaryNew';

import { registerLicense } from '@syncfusion/ej2-base';
import SpreadsheetUploader from './Screens/Components/rfpUploader/fileUploader';
import SimplePDFViewer from './Screens/Components/pdfViewer/documentOnlyViewer';
import PolicyDocumentViewer from './Screens/Components/policyDocumentViewer.tsx/policyDocumentViewer';
import { AppContext } from './context/appContext';
import BottomWarningBar from './Screens/Components/BottomBar';
import { ErrorBoundaryCustom } from './Screens/Components/errorScreen/ErrorBoundaryCustom';
import { TokenViewer } from './Screens/Components/accountViews/TokenList';
// import { GeneralChat } from './Screens/Components/Chat/GeneralChat';
import { PreviousSearch } from './Screens/Components/Chat/PrevSearch';
import { useAlert } from './context/alertContext';
import { useSearchHistory } from './context/searchHistoryContext';
import { ChatHistoryViewer } from './Screens/Components/Chat/chatHistoryViewer';
import { decode } from 'jsonwebtoken';
import UpdateAccount from './Screens/Components/accountViews/UpdateAccount';
import { AccountModal } from './Screens/Components/accountViews/accountModal';
import { GapAnalysis } from './Screens/Components/landingPage/GapAnalysisLanding';
import { createLogger } from './helpers/Logger';
import { UnauthorizedAccess } from './Screens/Components/errorScreen/unauthorizedError';
import { UserPreferences } from './Screens/Components/accountViews/userPreferences';
import { ExampleJSA } from './Screens/Components/JSA/jsa-page';
import QuestionnaireTable from './Screens/Components/questionTable/QuestionnaireTable';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXpfeXVdRmdZVkBwWkVWYUA='
);

const logger = createLogger({ prefix: '[APP]' });
// const isExistingUser = (token: string) => {
//   const decodedToken = decode(token) as unknown as any;
//   logger.info('decoded token', decodedToken);
//   if (!decodedToken) return false;
//   if (decodedToken?.hasOwnProperty('custom:customerId')) {
//     return true;
//   } else {
//     return false;
//   }
// };
export function App() {
  const { freeformSelectedItemsKB, freeformSelectedItemsQA } =
    useContext(DocumentContext);
  const { user } = useContext(UserContext);

  const { navOpen, setNavOpen } = useContext(AppContext);
  const { mainAlert, clearAlert, subsMainAlert } = useAlert();
  const baseNavItemsRef = useRef([
    { type: 'link', text: 'Projects', href: 'projects' },
    { type: 'divider' },
    { type: 'link', text: 'AI Assistant', href: 'search' },
    { type: 'link', text: 'GAP Assessment', href: 'gapanalysis' },
    { type: 'link', text: 'Questionnaire Library', href: 'answer-library' },
    { type: 'divider' }
  ]);

  const [navItems, setNavItems] = useState<any[]>(baseNavItemsRef.current);

  const [toolsOpen, setToolsOpen] = useState<boolean>(false);
  const [mainContainerWidth, setMainContainerWith] = useState<number>(100);
  const [mainContainerStyle, setMainContainerStyle] = useState<any>({});
  const searchContext = useSearchHistory();

  const navigate = useNavigate();
  let location = useLocation();
  // useEffect(() => {
  //   if (user.isAdmin) {
  //     const temp = navItems;
  //     const adminSection = {
  //       type: 'section',
  //       text: 'Admin',
  //       items: [
  //         { type: 'link', text: 'Manage Users', href: 'admin/users' },
  //         {
  //           type: 'link',
  //           text: 'View Credit Usage',
  //           href: 'admin/compliance-credits'
  //         },
  //         {
  //           type: 'link',
  //           text: 'Account',
  //           href: 'admin/account'
  //         }
  //       ]
  //     };

  //     temp.push(adminSection);
  //     logger.info('temp side nav', temp);
  //     setNavItems([...temp]);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [user.isAdmin]);
  //admin navigation
  useEffect(() => {
    if (!user.isAdmin) return;
    setNavItems((current) => {
      const withoutAdmin = current.filter((s) => s.text !== 'Admin');
      return [
        ...withoutAdmin,
        {
          type: 'section',
          text: 'Admin',
          items: [
            { type: 'link', text: 'Manage Users', href: 'admin/users' },
            {
              type: 'link',
              text: 'View Credit Usage',
              href: 'admin/compliance-credits'
            },
            { type: 'link', text: 'Account', href: 'admin/account' }
          ]
        }
      ];
    });
  }, [user.isAdmin]);
  useEffect(() => {
    if (
      (freeformSelectedItemsKB.length > 0 ||
        freeformSelectedItemsQA.length > 0) &&
      location.pathname === '/app/freeform'
    ) {
      setToolsOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [freeformSelectedItemsKB, freeformSelectedItemsQA]);
  useEffect(() => {
    if (toolsOpen) {
      setNavOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolsOpen]);
  useEffect(() => {
    if (location.pathname.includes('questionnaire')) {
      setToolsOpen(false);
    }
  }, [location.pathname, setToolsOpen]);

  useEffect(() => {
    if (location.pathname.includes('base')) {
      setNavOpen(false);
      setMainContainerWith(95);
    } else {
      setMainContainerWith(95);
    }
    if (location.pathname.includes('videos')) {
      setMainContainerWith(95);
    }
    if (location.pathname.includes('simple-viewer')) {
      setMainContainerWith(95);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // scroll events for the terms and conditiosn and the privacy statement
  useEffect(() => {
    logger.info('Path', location.pathname);
    if (
      location.pathname === '/app/landing' ||
      location.pathname === '/app/chat' ||
      location.pathname === '/app/base' ||
      location.pathname === 'app/simple-viewer'
    ) {
      setMainContainerStyle({
        width: `${mainContainerWidth}%`,
        maxHeight: '90vh',
        margin: '1% auto',
        overflowY: 'scroll',
        scrollbarWidth: 'none'
      });

      logger.info('main container style', mainContainerStyle);
    } else {
      setMainContainerStyle({
        width: `${mainContainerWidth}%`,
        maxHeight: '90vh',
        margin: '0% auto',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
        zIndex: '1000'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, mainContainerWidth]);

  //search navigation items
  // personal searches
  useEffect(() => {
    setNavItems((current) => {
      const withoutSearches = current.filter((s) => s.text !== 'AI Findings');
      if (!searchContext.history.length) return withoutSearches;
      return [
        ...withoutSearches,
        {
          type: 'section',
          text: 'AI Findings',
          items: searchContext.history.map((hist) => ({
            type: 'link',
            text: hist.originalQuestion,
            href: `searchhistory?historyId=${hist._id}`
          }))
        }
      ];
    });
  }, [searchContext.history]);

  // shared searches
  useEffect(() => {
    setNavItems((current) => {
      const withoutShared = current.filter(
        (s) => s.text !== 'Shared AI Findings'
      );
      if (!searchContext.sharedHistory.length) return withoutShared;
      return [
        ...withoutShared,
        {
          type: 'section',
          text: 'Shared AI Findings',
          items: searchContext.sharedHistory.map((hist) => ({
            type: 'link',
            text: hist.originalQuestion,
            href: `searchhistory?historyId=${hist._id}`
          }))
        }
      ];
    });
  }, [searchContext.sharedHistory]);

  return (
    <>
      <div style={{ height: '100vh' }}>
        <div style={{ position: 'fixed', top: 0, width: '100%', zIndex: 2000 }}>
          <TopNavigationBar />
        </div>
        <div
          style={{
            position: 'fixed',
            top: 55,
            width: '100%',
            zIndex: 1000
          }}
        >
          <AppLayout
            disableContentPaddings
            headerSelector=".b"
            toolsHide={true}
            // toolsOpen={false}
            navigationOpen={navOpen}
            onNavigationChange={() => {
              const newState = !navOpen;
              setNavOpen(newState);
            }}
            navigation={
              <SideNavigation
                header={{ href: 'landing', text: 'Services' }}
                items={navItems}
                onFollow={(event) => {
                  if (!event.detail.external) {
                    event.preventDefault();
                    navigate(`${event.detail.href}`);
                  }
                }}
              />
            }
            content={
              <div className="relative min-h-[90vh] max-h-[90vh] bg-transparent">
                {/* In-layout fixed background so AppLayout doesn't mask it */}
                <div className="fixed inset-0 z-0">
                  <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#62d29e]/40 via-[#62d29e]/20 to-white" />
                  <div className="absolute inset-0 opacity-[0.04] pointer-events-none [background-image:linear-gradient(to_right,theme(colors.slate.500/.35)_1px,transparent_1px),linear-gradient(to_bottom,theme(colors.slate.500/.35)_1px,transparent_1px)] [background-size:32px_32px]" />
                </div>
                {/* Foreground content */}
                <div
                  id="mainControl"
                  className="relative z-10"
                  style={{
                    ...mainContainerStyle
                  }}
                >
                  {mainAlert.showAlert ? (
                    <Alert
                      type={mainAlert.alertType}
                      dismissible
                      onDismiss={() => clearAlert()}
                    >
                      {mainAlert.message}
                    </Alert>
                  ) : null}
                  <ErrorBoundaryCustom key={location.pathname}>
                    <Routes>
                      <Route path="landing" element={<LandingPageNew />} />
                      <Route
                        path="answer-library"
                        element={<PreviousSearch />}
                      />
                      {/* <Route
                      path="landing/knowledgebase"
                      element={<KnowledgeBasePage />}
                    /> */}
                      <Route
                        path="projects/:projectId?"
                        element={<ProjectTableView />}
                      />

                      <Route
                        path="projects/:projectId?/folder/:folderId?"
                        element={<DocumentViewerContainer />}
                      />
                      <Route path="upload" element={<UploadDocument />} />
                      {/* <Route path="chat" element={<GeneralChat />} /> */}
                      <Route path="gapanalysis" element={<GapAnalysis />} />
                      <Route
                        path="search"
                        element={
                          <ChatWithSummaryNew
                            type={'main'}
                            goToSpecificPage={() => {}}
                            setPhraseArray={() => {}}
                            setShowSynopsys={() => {}}
                            setShowSearch={() => {}}
                          />
                        }
                      />
                      {/* <Route path="faq" element={<PreviousSearch />} /> */}
                      <Route
                        path="searchhistory"
                        element={<ChatHistoryViewer />}
                      />
                      {/* <Route path="changepassword" element={<ChangePassword />} /> */}
                      <Route
                        path="rfp-upload"
                        element={
                          <ErrorBoundaryCustom>
                            <SpreadsheetUploader />
                          </ErrorBoundaryCustom>
                        }
                      />
                      <Route
                        path="simple-viewer"
                        element={<SimplePDFViewer />}
                      />
                      <Route
                        path="policy-viewer"
                        element={<PolicyDocumentViewer />}
                      />
                      <Route path="jsa" element={<ExampleJSA />} />

                      <Route path="splash" element={<KnowledgeBaseSplash />} />

                      <Route
                        path="authError"
                        element={<UnauthorizedAccess />}
                      />
                      <Route
                        path="user-preferences"
                        element={<UserPreferences />}
                      />
                      <Route
                        path="questionnaire-table"
                        element={<QuestionnaireTable />}
                      />

                      <Route path="/admin/*" element={<AdminRoute />}>
                        <Route path="uploadcsv" element={<UploadCSV />} />
                        <Route path="edit" element={<EditDomains />} />
                        <Route path="users" element={<ManageUsers />} />
                        <Route path="errorlogs" element={<ErrorReports />} />
                        <Route path="account" element={<UpdateAccount />} />

                        <Route
                          path="costcalculator"
                          element={<CostCalculator />}
                        />
                        <Route
                          path="compliance-credits"
                          element={<TokenViewer />}
                        />
                      </Route>
                    </Routes>
                  </ErrorBoundaryCustom>
                  {subsMainAlert.showAlert && <AccountModal />}
                </div>
              </div>
            }
            // breadcrumbs={
            //   <>
            //     <Routes>
            //       <Route
            //         path="projects/:projectId?/folder/:folderId?"
            //         element={<ProjectBreadcrumbs />}
            //       />
            //       <Route path="/base" element={<DocumentBreadcrumbs />} />
            //     </Routes>
            //   </>
            // }
          />
        </div>

        <div
          style={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 1000 }}
        >
          <BottomWarningBar />
        </div>
      </div>
      <>
        <TandCModal />
      </>
    </>
  );
}
